import {BaseApi} from '@/core/api/base.api'
import {Room} from '@/core/api/room.api'
import {RoomUser} from '@/core/api/room.user.api'
import {roomGroupService} from '@/core/service/room.group.service'
import _ from 'lodash'
import { RoomInfo } from '@/core/api/room.info.api'

class RoomGroupApi extends BaseApi {
  #roomGroupService;

  constructor() {
    super()
    Room.Group = this

    Room.ready(async e => {
      if(!RoomInfo.useModule('roomGroup')){
        return;
      }

      this._eventListen(this.#Events)
      // TODO: lms 용 그룹 갖고 오기 위함
      this.#roomGroupService = roomGroupService

      let { data } = await this.#roomGroupService.getRoomGroupList()
      data.forEach(roomGroupData => {
        this.addData(roomGroupData.roomGroupId, roomGroupData)
      });
    })
  }

  addData(roomGroupId, data) {
    if(!data){
      return this;
    }

    let roomData = Room.getRoomData();
    if(!roomData.roomGroupList){
      roomData.roomGroupList = [];
    }else{
      //
    }

    let roomGroupData = roomData.roomGroupList.find(rg => rg.roomGroupId === roomGroupId);
    if(!roomGroupData){
      roomGroupData = {roomGroupId};
      roomData.roomGroupList.push(roomGroupData);
    }
    _.assign(roomGroupData, data)
    // TODO: roomDoc 없을 경우 고려해서 넣어 줌
    if(!roomGroupData.roomDoc) {
      roomGroupData.roomDoc = {roomDocFiles:[]}
    }
    return this
  }

  getRoomGroup(roomGroupId) {
    let roomData = Room.getRoomData();
    let roomGroup = roomData.roomGroupList.find(rg => rg.roomGroupId === roomGroupId);
    return roomGroup;
  }

  getRoomGroupList() {
    return Room.getRoomData().roomGroupList
  }
  isInRoomGroup(roomUser){
    if(!roomUser) roomUser = Room.getRoomData().me
    if(typeof roomUser === 'string') {
      roomUser = roomUser.getRoomUser(roomUser)
    }
    return Room.isRoomGroupMode() && roomUser && roomUser.roomGroupId && roomUser.roomGroupId !== 'default';
  }

  removeRoomGroupList(roomGroupId) {
    let roomGroupList = Room.getRoomData().roomGroupList
    if(roomGroupId) {
      if(!Array.isArray(roomGroupId)) {
        roomGroupId = [roomGroupId]
      }
      roomGroupList = roomGroupList.filter(roomGroup => !!roomGroupId.find(rg => rg == roomGroup.roomGroupId))
    }
    for(let i = 0; i<roomGroupList.length; i++) {
      if(roomGroupList[i].roomGroupId !== 'default') {
        roomGroupList[i].del = true
      }
    }
  }
  setRoomGroupList(roomGroupList) {
    if(!roomGroupList || !roomGroupList.length) {
      return;
    }
    roomGroupList.forEach(roomGroup => {
      this.addData(roomGroup.roomGroupId, roomGroup)
    })
  }
  addRoomDocList(roomDocList) {
    if(!roomDocList || !roomDocList.length) {
      return;
    }
    roomDocList.forEach(roomDoc => {
      if(!roomDoc.roomDocFiles.length){ // roomDocFile 빈값 고려
        delete roomDoc.roomDocFiles
      }
      this.addData(roomDoc.roomGroupId, {roomDoc})
    })
  }

  roomGroupListNoDefaultActive() {
    return Room.getRoomData().roomGroupList.filter(roomGroup => roomGroup.roomGroupId !== 'default' && (roomGroup.del !== undefined && !roomGroup.del))
  }

  noContentGroupMode() {
    let idx = this.roomGroupListNoDefaultActive().findIndex(rg => !!rg.mode);
    return idx < 0
  }

  createRoomGroup(roomGroupList) {
    return this.#roomGroupService.createRoomGroup(roomGroupList)
  }

  startRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}) {
    return this.#roomGroupService.startRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea})
  }

  createAndStartRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}) {
    return this.#roomGroupService.createAndStartRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea})
  }

  endRoomGroup(roomGroupId) {
    return this.#roomGroupService.endRoomGroup(roomGroupId)
  }

  addRoomGroup(roomGroupList) {
    return this.#roomGroupService.addRoomGroup(roomGroupList)
  }

  removeRoomGroup(roomGroupList) {
    return this.#roomGroupService.removeRoomGroup(roomGroupList)
  }

  eraseRoomGroupUser({userId, roomGroupId}) {
    return this.#roomGroupService.eraseRoomGroupUser({userId, roomGroupId})
  }

  async setRoomUserGroup({userId, roomGroupId}) {
    return await this.#roomGroupService.setRoomUserGroup({userId, roomGroupId})
  }

  regRoomGroupSubject(roomGroupSubjectList) {
    return this.#roomGroupService.regRoomGroupSubject(roomGroupSubjectList)
  }

  removeRoomGroupSubject(roomGroupId) {
    return this.#roomGroupService.removeRoomGroupSubject(roomGroupId)
  }

  addRoomGroupsDurationTime(roomGroupDurationList) {
    return this.#roomGroupService.addRoomGroupsDurationTime(roomGroupDurationList)
  }

  async changeHideRoomGroupUserInFilmArea(data) {
    return await this.#roomGroupService.changeHideRoomGroupUserInFilmArea(data)
  }

  async changeRoomGroupMicMuteState(data) { return await this.#roomGroupService.changeRoomGroupMicMuteState(data) }

  async changeRoomGroupSpeakerMuteState(data) { return await this.#roomGroupService.changeRoomGroupSpeakerMuteState(data) }
  #Events = {
    room_group_changeRoomGroup(e) {
      let data = e.data

      RoomUser.changeRoomUserRoomGroupId(data.userId, data.roomGroupId)
      Room.emit(e.type, {roomGroupId: data.roomGroupId, userId: data.userId})
      Room.emit('room_set_newUser')
    },
    room_group_startLoadingRoomGroupMode() {
      // loadingScreen 시작
      Room.emit('set_loading_group_mode', true)
    },
    room_group_setRoomGroup(e) {
      const { roomGroupList } = e.data
      this.setRoomGroupList(roomGroupList)

      Room.emit(e.type, {
        roomGroupList : _.cloneDeep(roomGroupList)
      })
    },
    room_group_resetRoomUserGroup(e) {
      this.removeRoomGroupList()
      RoomUser.resetAllRoomUserRoomGroupIdDefault()
      Room.emit(e)
    },
    room_group_removeRoomGroup(e) {
      const { roomGroupIds } = e.data
      this.removeRoomGroupList(roomGroupIds)
      RoomUser.resetAllRoomUserRoomGroupIdDefault(roomGroupIds)
      Room.emit(e)
    },
    room_group_message(e) {
      Room.emit(e)
    },
    room_group_changeMode(e) {
      let {roomGroupId, mode} = e.data;

      function set(roomGroup){
        if(!roomGroup){
          return;
        }
        roomGroup.mode = mode;
        Room.emit({type: e.type, data: roomGroup});
      }

      if(roomGroupId === 'all'){
        this.getRoomGroupList().forEach(set);
      }else{
        let roomGroup = this.getRoomGroup(roomGroupId);
        set(roomGroup);
      }
    },
    room_group_set_speaker(e) {
      Room.emit(e);
    },
    room_group_set_mic(e) {
      Room.emit(e);
    },
    room_group_changeLayoutType(e) {
      let {roomGroupId, videoLayout} = e.data
      const roomGroup = this.getRoomGroup(roomGroupId)
      if(roomGroup) {
        roomGroup.videoLayout = videoLayout
      }
      Room.emit(e)
    }
  }
}

export const roomGroupApi = new RoomGroupApi()
